"use client";
import React from "react";
import { Button } from "@int-traderjoes/ui-components-library";
import { useTheme } from "@/context";

export interface DownloadButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  primary?: boolean;
  size?: "small" | "medium" | "large";
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
  text,
  onClick,
  disabled = false,
  className = "",
  primary = true,
  size = "medium",
}) => {
  const { darkMode } = useTheme();
  const darkModeClass = darkMode ? "dark-mode" : "";

  return (
    <Button
      className={`${darkModeClass} action-button-inline ${className}`}
      size={size}
      text={text}
      onClick={onClick}
      primary={primary}
      disabled={disabled}
    />
  );
};

export default DownloadButton;

